import { render, staticRenderFns } from "./centerDialog.vue?vue&type=template&id=00015c32&"
import script from "./centerDialog.vue?vue&type=script&lang=js&"
export * from "./centerDialog.vue?vue&type=script&lang=js&"
import style0 from "./centerDialog.vue?vue&type=style&index=0&id=00015c32&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports